import React from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import VideoMockInterview from "@/pages/VideoMockInterview";

/**
 * Practice - step 03 of the canonical Intuiterview journey.
 * Mock Interview only: rehearse the answers prepared in Step 02 (Predict &
 * Prepare) with AI coaching, before the Official AI Interview (Step 04).
 */
export default function InterviewPractice() {
  const [params] = useSearchParams();

  // Legacy deep links: answer preparation now lives in Step 02.
  if (params.get("step") === "prepare") {
    const qs = params.get("question_set_id");
    const q = params.get("q");
    const query = qs ? `?question_set_id=${qs}${q ? `&q=${q}` : ""}` : "";
    return <Navigate to={`/app/prep${query}`} replace />;
  }

  return (
    <div data-testid="practice-page" className="animate-in">
      <div className="mb-6 flex flex-wrap items-center justify-end gap-3">
        <Link
          to="/app/live"
          data-testid="practice-ready-official-btn"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-300 hover:text-amber-200 transition-colors"
        >
          Ready for the Official Interview <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <VideoMockInterview />
    </div>
  );
}
